<template lang="pug">
    section#mosaico
        ul.mosaico
            li(v-for="item, index in getImage", :class="`_0${index+1}`")
                img(:src="item.image")
        .content
            Editor(:contents="editor")
            Link(:contents='contents.content').link {{contents.content.name}}
</template>

<script>
import { props } from '@/mixins/component'
import Link from '@components/Link/Link'
import Editor from '@sections/Pagina/Editor/Editor'

export default {
    name: "section-mosaico",
    props,
    components: {
        Editor,
        Link,
    },
    computed: {
        getImage() {
            return this.contents.content.mosaico.map(item => ({
                ...item,
                image: item
            }))
        },
        editor() {
            return {content: this.contents.content.editor}
        },
    },
}
</script>

<style lang="stylus" scoped src="./MosaicoHomeSection.styl"></style>
